import * as types from '../../../../../../constants/ActionNameConstants';

const INITIAL_STATE = {
  loading: false,
  user: [],
  error: null,
};

const StateListReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.EDIT_STATE_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.EDIT_STATE_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload,
      };
    case types.EDIT_STATE_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default StateListReducer;
